<template>
  <div :class="{ 'px-3 bg-card-bg-gray': $bus.params.isTemp }" v-if="viewStatus">
    <div
      :class="['home', 'overflow-y-auto', 'overflow-x-hidden', $bus.params.isTemp ? 'bg-white' : '', $bus.params.isTest && !$bus.params.noTip ? 'test-top' : '']"
      :style="homeStyle">
      <div v-if="$bus.isStart && !$bus.isEnd">
        <div class="progress-wrapper" :class="{ 'progress-wrapper-no-bottom': $bus.params.isTest && !$bus.params.noTip }"
          v-if="showProgress">
          <van-progress class="overflow-hidden rounded-none" :percentage="percent" :class="progressClass"
            :stroke-width="10" color="var(--progress-color)" />
        </div>
        <div class="text-yellow-theme text-medium flex items-center justify-center"
          style="height: 32px;background: #FFFCEB;font-weight: 500; position: fixed; top: 10px;left: 0;right: 0;z-index: 100;"
          v-if="$bus.params.isTest && !$bus.params.noTip">
          当前为手机模拟答题，提交的答卷不会保存
        </div>
        <div class="text-center mt-1" v-if="maxAnswerTime > 0">
          <span>当前答题时间剩余</span>
          <span class="ml-2" :class="{ 'text-red': maxAnswerTime <= 10 }">{{ remainingTime }}</span>
        </div>
        <div class="text-center mt-1" v-if="maxPageAnswerTime > 0">
          <span>当前页答题时间剩余</span>
          <span class="ml-2" :class="{ 'text-red': maxPageAnswerTime <= 10 }">{{ maxPageTime }}</span>
        </div>
      </div>
      <template v-if="$bus.isSurveyLoad">
        <template v-if="!$bus.isStart && !$bus.isEnd">
          <answer-info :footerStatus="footerStatus" />
        </template>
        <template v-else-if="$bus.isStart && !$bus.isEnd">
          <template v-if="themeHeaderShow">
            <!-- <div class="px-4 mt-3">
              <img :src="themeHeaderImage" alt="" class="max-w-full" @load="onThemeHeaderLoad" />
            </div> -->
            <DisplayHeader :themeHeader="themeHeader" class=""></DisplayHeader>
          </template>
          <template v-if="showPureHeader">
            <award-notice-wrapper />
            <!--            <award-notice />-->
            <pure-title-and-welcome class="mt-8" />
          </template>
          <!-- 样本追踪查看答案 -->
          <ViewAnswer v-show="isShowCheckAnswer" @update-show-answer="(v) => { isShowCheckAnswer = v }" />
          <answer-content ref="content" :footerStatus="footerStatus" />
        </template>
        <template v-else-if="$bus.isEnd">
          <answer-end :footerStatus="footerStatus" />
        </template>
      </template>
      <v-code :show="showVerification" @success="$bus.onVerificationSuccess" @close="$bus.onVerificationClose" />
    </div>
    <div v-if="$bus.params.isTemp" style="height: 76px; box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.06)"
      class="box-border text-center p-3 -mx-3 bg-white">
      <van-button @click="createWj" class="w-full text-medium-x h-10 py-0.5" style="color: #fff" type="primary"
        size="small">使用此模板创建问卷
      </van-button>
      <van-popup v-model:show="popupTipShow">
        <div class="m-2">
          请使用电脑端或者微信搜索小程序“调研工厂”使用该模板创建问卷，回收数据
        </div>
        <van-button class="mb-3" type="primary" size="small" @click="popupTipShow = false">我知道了</van-button>
      </van-popup>
    </div>
  </div>
</template>
<script>
import {
  getSurvey,
  normalizeUrlParams,
  busGetters,
  formatSeconds,
  merge,
  createStyle,
  bingAnswerAndGetUser,
  ErrorCode,
  bindExtraAward,
  OAUTH_INFO_API_URL,
  getUserById,
  updateUserByWxCode,
  getSurveyPoint,
  getStatusConfig
} from 'dygc'
import AnswerInfo from '@/components/AnswerInfo'
import AnswerEnd from '@/components/AnswerEnd'
import Question from '@/components/Question'
import AnswerContent from '@/components/AnswerContent'
import VCode from 'vue-puzzle-vcode'
import PureTitleAndWelcome from '@/components/PureTitleAndWelcome'
import { registerShare } from '@/assets/js/jssdk'
import AwardNotice from '@/components/AwardNotice'
import { convertObjToUrlSearch } from '@survey/util'
import { createPopup } from '../assets/js/factory'
import BeforeLeaveOverlay from '../components/overlay/BeforeLeaveOverlay.vue'
import DisplayHeader from '@/components/DisplayHeader'
import AwardNoticeWrapper from '../components/reward/AwardNoticeWrapper.vue'
import OverlayError from '../components/overlay/OverlayError.vue'
import ViewAnswer from '@/components/ViewAnswer'

export const defaultsDesc = [
  '一起来填问卷，让我们的意见被听见！',
  '你的意见，可以影响世界！',
  '你的意见，将是决策意见！',
  '发表意见，也是一种建设！',
  '人人都是决策者！'
]

export default {
  name: 'Home',
  components: {
    AwardNoticeWrapper,
    AwardNotice,
    PureTitleAndWelcome,
    AnswerContent,
    AnswerEnd,
    AnswerInfo,
    Question,
    DisplayHeader,
    ViewAnswer,
    VCode: {
      extends: VCode,
      methods: {
        onClose() {
        }
      }
    }
  },
  data() {
    return {
      themeHeader: null,
      popupTipShow: false,
      viewStatus: true,
      footerStatus: true,
      imgUrl: '',
      isShowCheckAnswer: false
    }
  },
  created() {
    // 答完题 查看内容 点击浏览器返回 不需要任何操作 就显示离开之前的页面即可
    if (this.$bus.answerId && this.$bus.isEnd) return
    const params = this.$bus.params
    if (!params.surveyId) {
      createPopup(OverlayError, {}, {})
      return
    }
    this.initHooks()
    this.$bus.openLoading()
    if (params.code || params.accountUserId) {
      const { surveyId, answerId, code, pageType } = params
      if (answerId && pageType !== "1") {
        bingAnswerAndGetUser(code, params.accountUserId, surveyId, answerId).then(res => {
          this.$bus.params.accountUserId = res.data.accountUserId
          // this.$bus.hook.run('userLogin')
          // bindAnswerStatus: null
          // bindOtherAnswer: 0
          // bindThisAnswer: 0
          // otherReceived: 0
          // receivedOvertime: 0
          if ((res.data.bindAnswerStatus && !res.data.bindThisAnswer) || res.data.receivedOvertime || res.data.bindOtherAnswer || res.data.otherReceived) {
            this.$bus.busOption.overlay({
              code: ErrorCode.AWARD_ERROR,
              data: res.data
            })
            this.$bus.closeLoading()
          } else {
            this.init()
          }
          // this.init()
        })
      } else if (params.code) {
        updateUserByWxCode(params.code).then(res => {
          this.$bus.params.accountUserId = res
          this.init()
        })
      } else {
        this.init()
      }
    } else {
      this.init()
    }
    // 答题换壳
    // if(!params.companyid) return

  },
  computed: {
    showProgress() {
      return this.$bus.survey.otherSetting.progressStatus !== 0
    },
    homeStyle() {
      const params = this.$bus.params
      const height = this.$bus.params.isTemp ? 'calc(100vh - 76px)' : 'auto'
      if (!params.isTest) return { height }
      if (!params.clientWidth) return { height }
      return {
        width: parseInt(params.clientWidth) + 'px',
        height
      }
    },
    showPureHeader() {
      return !this.enableHomePage && this.currentPageNum === 0
    },
    progressClass() {
      if (this.isStart && !this.isEnd) {
        return 'visible'
      } else {
        return 'invisible'
      }
    },
    remainingTime() {
      return formatSeconds(this.maxAnswerTime)
    },
    minPageTime() {
      return formatSeconds(this.minPageAnswerTime)
    },
    maxPageTime() {
      return formatSeconds(this.maxPageAnswerTime)
    },
    themeHeaderImage() {
      const themeHeader = this.themeHeader
      if (!themeHeader) return
      if (!themeHeader.show || !themeHeader.image) return
      return window.location.origin + '/fill/api/v1/download?fileName=' + themeHeader.image
    },
    themeHeaderShow() {
      const themeHeader = this.themeHeader
      if (!themeHeader) return true
      if (themeHeader.show && ((!themeHeader.type) || (themeHeader.type == 'image' && !themeHeader.image))) return true
      if (!themeHeader.show || (!themeHeader.image && themeHeader.image != 'none' && !themeHeader.text && themeHeader.carouselImageList?.length == 0)) return false
      return true
    },
    ...busGetters([
      'percent',
      'isStart',
      'isEnd',
      'showVerification',
      'maxAnswerTime',
      'minPageAnswerTime',
      'maxPageAnswerTime',
      'enableHomePage',
      'currentPageNum',
      'isSurveyLoad'
    ])
  },
  watch: {
    showPureHeader() {
      this.$nextTick(() => {
        if (this.$refs.content) this.$refs.content.initHeight()
      })
    },
    isShowCheckAnswer() {
      this.$nextTick(() => {
        if (this.$refs.content) this.$refs.content.initHeight()
      })
    }
  },
  methods: {
    getCompanyStyle(companyid) {
      getStatusConfig(companyid, ["out_D55", "out_D55_D", "out_D72_2"]).then(res => {
        if (res?.code !== 0) return
        this.viewStatus = res.data.out_D55 === "1"
        this.footerStatus = res.data.out_D55_D === "1"
        this.imgUrl = res.data.out_D72_2
      })
    },
    init() {
      const params = this.$bus.params
      if (params.accountUserId) {
        getUserById(params.accountUserId)
          .then(res => {
            if (!res.weixinNickName || !res.weixinHeadimgurl) {
              this.$bus.user = null
            } else {
              this.$bus.user = {
                weixinNickName: res.weixinNickName,
                weixinHeadimgurl: res.weixinHeadimgurl
              }
            }
            this.initSurvey()
          })
          .catch(() => {
            this.initSurvey()
          })
      } else {
        this.initSurvey()
      }
    },
    initSurvey() {
      const params = this.$bus.params
      getSurvey(params)
        .then(res => {
          if (res.channel && (res.channel.channelType || '').toString() === '2') {
            return getSurveyPoint(params.surveyId)
              .then(surveyPoint => {
                this.$bus.init(Object.assign({}, res, { surveyPoint }))
              })
              .catch(() => {
                this.$bus.init(Object.assign({}, res), params)
              })
          } else {
            this.$bus.init(Object.assign({}, res), params)
          }
        })
        .then(() => {
          this.getCompanyStyle(this.$bus.survey.companyId)
        })
        .catch(this.$bus.initError)
    },
    onThemeHeaderLoad() {
      this.$refs.content.initHeight()
    },
    initShare(shareOption = {}) {
      const bus = this.$bus
      const params = bus.params
      let otherSetting = bus.survey.otherSetting || {}
      if (otherSetting.disabledWxOperate) {
        wx.hideAllNonBaseMenuItem()
        wx.showMenuItems({
          menuList: []
        })
        return
      }
      const shareSetting = otherSetting.shareOtherSetting || {}
      const defaults = {
        title: bus.survey.title,
        desc: bus.survey.welcome || defaultsDesc[(Math.random() * defaultsDesc.length) | 0],
        icon: null,
        ...shareOption
      }
      const data = merge(shareSetting, defaults)
      const origin = window.location.origin
      const answerChannelId = this.$bus.channel.id
      data.title = this.transformShareTitle(data.title)
      const urlParam = {
        surveyId: bus.survey.id,
        answerChannelId: answerChannelId,
        shareAnswerId: bus.answerId,
        pageType: '1',
        companyid: params.companyid,
        shareAccountUserId: bus.params.accountUserId
      }

      const returnUrl = `${origin}/mobile?${convertObjToUrlSearch(urlParam)}`
      const link = `${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(returnUrl)}`
      const imgUrl = this.imgUrl

      registerShare({ ...data, link, imgUrl }, bus.answerId, bus.params.accountUserId, () => {
        if (bus.isEnd) {
          if (bus.survey.otherSetting.extraChanceToGetAward) {
            bus.currentPageIsShare = true
          }
        }
      })
    },
    transformShareTitle(title) {
      const reg = /\${{(?:([^$]*))}}/g
      let result = null
      let res = title
      while ((result = reg.exec(title))) {
        let vals = result[1].split('.')
        let val = vals.reduce((obj, item) => {
          if (!obj) return ''
          return obj[item]
        }, this.$bus)
        res = res.replace(result[0], val || '')
      }
      return res
    },
    platformSdkLoad() {
      if (!this.$bus.currentBrowserInfo.isWeixin) {
        return
      }

      if (this.$bus.isSurveyLoad) {
        this.initShare()
      } else {
        this.$bus.hook.on('surveyLoad', () => {
          this.initShare()
        })
      }
      this.$bus.hook.on('answerStart', () => {
        this.initShare()
      })
      this.$bus.hook.on('answerOver', () => {
        const survey = this.$bus.survey
        if (survey.otherSetting.enableInterestingAnswer) {
          if (this.$bus.scoreEnd && this.$bus.scoreEnd.testResult) {
            this.initShare({
              title: this.$bus.scoreEnd.testResult + '，' + survey.title
            })
            return
          }
        }
        this.initShare()
      })
      this.$bus.hook.on('resetShare', (option = {}) => {
        this.initShare(option)
      })
    },
    initHooks() {
      const bus = this.$bus
      let hook = bus.hook
      hook.on('surveyLoad', () => {
        let otherSetting = bus.survey.otherSetting || {}
        this.themeHeader = otherSetting.themeHeader
        const cover = otherSetting.cover || { startBtn: {} }
        createStyle({
          themeBtnColor: cover.startBtn.bgColor,
          themeBtnTextColor: cover.startBtn.textColor,
          coverImage: cover.image,
          buttonOption: otherSetting.buttonOption || {},
          background: otherSetting.background || {}
        })
      })
      hook.on('beforeAnswerOver', () => {
        let otherSetting = bus.survey.otherSetting || {}
        this.themeHeader = otherSetting.themeHeader
        const cover = otherSetting.cover || { startBtn: {} }
        if (otherSetting.answerEndBackground && otherSetting.answerEndBackground.image) {
          console.log("otherSetting.answerEndBackground",otherSetting.answerEndBackground)
          createStyle({
            themeBtnColor: cover.startBtn.bgColor,
            themeBtnTextColor: cover.startBtn.textColor,
            coverImage: cover.image,
            buttonOption: otherSetting.buttonOption || {},
            background: otherSetting.answerEndBackground
          })
        }

      })
      hook.on('answerStart', () => {

        setTimeout(() => {
          if (this.$bus.currentCount > 0) {
            this.initPopstate()
            return
          }
          this.$bus.pageList.forEach(q => {
            q.setHook('updated', this.initPopstate)
          })
        }, 50)
      })
      if (this.$bus.platformSdkFinished) {
        this.platformSdkLoad()
      } else {
        this.$bus.hook.on('platformSdkLoad', this.platformSdkLoad)
      }
      this.$bus.hook.on('userLogin', () => {
        this.initShare()
      })
      if (bus.params.isTest) {
        window.addEventListener('message', event => {
          let data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data
          if (data.message !== 'CHANGE_THEME') return
          let otherSetting = bus.survey.otherSetting || {}
          const d = data.payload
          const cover = (otherSetting.cover = Object.assign({}, otherSetting.cover || {}, d.cover || {}))
          this.themeHeader = otherSetting.themeHeader = Object.assign({}, otherSetting.themeHeader || {}, d.themeHeader || {})
          otherSetting.buttonOption = Object.assign({}, otherSetting.buttonOption || {}, d.buttonOption || {})
          if ('enableAnswerCount' in d) {
            otherSetting.enableAnswerCount = d.enableAnswerCount
          }
          if ('enableHideTitleWelcome' in d) {
            otherSetting.enableHideTitleWelcome = d.enableHideTitleWelcome
          }

          bus.survey.otherSetting = Object.assign({}, otherSetting)
          this.$set(otherSetting, 'cover', cover)
          createStyle({
            themeBtnColor: cover.startBtn?.bgColor,
            themeBtnTextColor: cover.startBtn?.textColor,
            coverImage: cover.image,
            buttonOption: otherSetting.buttonOption || {}
          })
        })
      }
    },
    createWj() {
      console.log('使用模板')
      if (this.$bus.params.isBaidu) {
        this.popupTipShow = true
        return
      }
      const surveyId = this.$bus.params.surveyId
      uni.webView.redirectTo({
        url: `/features/template/pages/templatePreview?surveyId=${surveyId}&mpWx=true`
      })
    },
    initPopstate: (function () {
      let f = false

      return function () {
        if (f) return
        f = true
        const bus = this.$bus

        if (!bus.currentBrowserInfo.isWeixin) return
        if (!bus.survey.otherSetting.enableLuck) return
        const popstateHandler = this.popstateHandler
        const answerOver = (function () {
          return () => {
            bus.hook.off("answerOver", answerOver)
            window.removeEventListener('popstate', popstateHandler)
            f = false
            window.history.back()
          }
        })()
        this.pushState()
        window.addEventListener('popstate', popstateHandler)
        bus.hook.on("answerOver", answerOver)
      }
    })(),
    pushState() {
      const state = {
        url: '#'
      }
      window.history.pushState(state, '', '#')
    },
    popstateHandler() {
      const closeWindow = () => {
        this.$answerUtil.getEnv().then(res => {
          if (res.miniprogram) {
            wx.miniProgram.navigateBack({ delta: 1 })
          } else {
            if (bus.currentBrowserInfo.isWeixin) {
              wx.closeWindow()
            } else {
              window.close()
            }
          }
        })
      }
      const bus = this.$bus
      if (!bus.currentCount || bus.isEnd) {
        return
      }
      this.pushState()
      const vm = createPopup(BeforeLeaveOverlay, {
        surveyId: this.$bus.survey.id,
        answerId: this.$bus.answerId
      })
      vm.$on('confirm', () => {
        vm.$emit('close')
      })
      vm.$on('cancel', () => {
        closeWindow()
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.popstateHandler)
  }
}
</script>
